<template>
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width="14"
        height="8"
        viewBox="0 0 14 8"
        fill="none"
        :class="{rotated: rotated}"
    >
        <path
            d="M1 0.999999L6.29289 6.29289C6.62623 6.62623 6.79289 6.79289 7 6.79289C7.20711 6.79289 7.37377 6.62623 7.70711 6.29289L13 1"
            stroke="currentColor"
            stroke-width="1.5"
            stroke-linecap="round"
            stroke-linejoin="round"

        />
    </svg>
</template>
<script>
export default {
    name: "ArrowDown",
  rotated:Boolean
};

// defineProps({
//
// })
</script>

<script setup>
defineProps({
  rotated:Boolean
})
</script>


